import MedicalRecordWaiverList from './MedicalRecordWaiverList';
export default MedicalRecordWaiverList;